import type { LessonContent } from "@/lib/lesson-content/schema";
import { GPU_LESSON_FIXTURE } from "@/lib/ile/fixtures/gpu-lesson";
import { parseLessonContentWithLegacy } from "@/lib/ile/legacy-migrate";

export function isBlocksLesson(value: unknown): boolean {
  return parseLessonContentWithLegacy(value) !== null;
}

export function getBlocksLesson(value: unknown): LessonContent | null {
  return parseLessonContentWithLegacy(value);
}

/** Resolves blocks lesson from structured content, with optional dev mock fallback. */
export function resolveBlocksLesson(structuredContent: unknown): LessonContent | null {
  const direct = getBlocksLesson(structuredContent);
  if (direct) {
    return direct;
  }
  if (process.env.NEXT_PUBLIC_ILE_MOCK === "1") {
    return GPU_LESSON_FIXTURE;
  }
  return null;
}
